import React, { Fragment } from "react";
import map from "lodash.map";
import isEmpty from "lodash.isempty";
import { Button } from "../../Button";
import { BudgetPageType } from "../../../utils/enums";
import { Loader } from "../../Loader";

import { Attachment } from "../../Attachment";

function getTitle(budgetPage) {
  switch (budgetPage.type) {
    case BudgetPageType.Help: {
      return `Pomoc: ${budgetPage.budgetTitle}`;
    }
    case BudgetPageType.Prerequisite: {
      return `Do pobrania: ${budgetPage.budgetTitle}`;
    }
    case BudgetPageType.Schedule: {
      return `Harmonogram: ${budgetPage.budgetTitle}`;
    }
    default: {
      return "";
    }
  }
}
function renderAttachmentsIcon(type) {
  switch (type) {
    case "application/pdf": {
      return (
        <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
      );
    }
    default: {
      return (
        <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
      );
    }
  }
}
export const BudgetPageCard = ({ ...props }) => (
  <Fragment>
    {props.isBudgetPageLoading && (
      <Loader loading={props.isBudgetPageLoading} />
    )}
    {!props.isBudgetPageLoading && (
      <div id="content" className="container">
        <h2 className="page__title">{getTitle(props)}</h2>
        <div
          className="page__content"
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
        {!isEmpty(props.attachments) && (
          <div className="page__attachments">
            <div className="attachments-list">
              {map(props.attachments, (attachment) => (
                <Attachment
                  key={attachment.id}
                  {...{
                    attachment,
                    url: `/api/budget/${props.budgetId}/pages/${props.id}/attachments/${attachment.id}`,
                  }}
                >
                  {renderAttachmentsIcon(attachment.contentType)}
                </Attachment>
              ))}
            </div>
          </div>
        )}
        <div className="buttons margin-top-20 margin-bottom-20">
          <Button variant="danger" onClick={props.onCancel}>
            Powrót
          </Button>
        </div>
      </div>
    )}
  </Fragment>
);
